import script from "./audit-backup.vue?vue&type=script&setup=true&lang=ts"
export * from "./audit-backup.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=94679a52&scoped=true&lang=css&external"
import "./audit-backup.vue?vue&type=style&index=1&id=94679a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94679a52"]])

export default __exports__